const E = "update:modelValue", t = "change", e = "input";
export {
  t as CHANGE_EVENT,
  e as INPUT_EVENT,
  E as UPDATE_MODEL_EVENT
};
